import React, { ChangeEvent } from "react";
import { TextField, Autocomplete } from "../../../common/MaterialComponent";
import { useGetComponentStringsContext } from "../../../hooks/useGetComponentStrings";

export interface TimeZoneSelectionProps {
	onTimeZoneChange: Function;
	timeZoneList: string[];
	selectedTimeZone: string;
	isReadOnly: boolean;
	requiresValidation: boolean;
}

const TimeZoneSelection = (props: TimeZoneSelectionProps) => {
	const strings = useGetComponentStringsContext().TimeZoneSelection;
	return (
		<>
			<Autocomplete
				data-testid="timeZoneSelection"
				options={props.timeZoneList}
				onChange={(event: ChangeEvent<{}>, value: string | null) =>
					props.onTimeZoneChange(value)
				}
				autoHighlight
				value={props.selectedTimeZone}
				disableClearable={props.isReadOnly}
				getOptionSelected={(option, value) => !value || option === value}
				getOptionDisabled={() => props.isReadOnly}
				renderInput={(params) => (
					<TextField
						{...params}
						data-testid="timeZoneInput"
						label={strings.timeZoneLabel}
						error={!props.selectedTimeZone && props.requiresValidation}
						helperText={
							!props.selectedTimeZone && props.requiresValidation
								? strings.timeZoneRequiredMessage
								: ""
						}
						disabled={props.isReadOnly}
					/>
				)}
			/>
		</>
	);
};

export default TimeZoneSelection;
